// reportSyncSingleton.ts
let isSyncing = false;

export const reportSyncSingleton = {
  isSyncing: () => isSyncing,

  sync: async (syncFn: () => Promise<void>) => {
    if (isSyncing) return;
    isSyncing = true;

    try {
      await syncFn();
    } finally {
      isSyncing = false;
    }
  },
};
